import React, {useEffect, useRef, useState} from 'react';
import Table4 from "../../../components/Table4";
import {Input} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import {ExcelPrint, Pdf, PrintElem} from "../../../../../components/functions/Print";
import print from "../../../../../icons/print.png";
import {NavLink} from "react-router-dom";
import pdf from "../../../../../icons/pdf.png";
import excel from "../../../../../icons/excel.png";
import $ from "jquery";
import axios from "axios";
import {header} from "../../../../../components/api/Header";
import {monthDays, monthName} from "../../../../../components/functions/Month";
import {useReactToPrint} from "react-to-print";
import { getEnv } from "../../../../../lib/env";

function Page3({month}) {
    const conponentPDF= useRef();
    const [data, setData] = useState([])
    let sums1 = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
    let sums2 = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
    let day = 1;
    const setSearch = (text) => {
        $('tbody tr').each(function(){
            if ($(this)[0].className.toUpperCase().indexOf(text.toUpperCase()) > -1) {
                $(this)[0].style.display = "";
            } else {
                $(this)[0].style.display = "none";
            }
            if(text!=''){
                $('tbody tr.j-tr').css("display","none")
            }else {
                $('tbody tr.j-tr').css("display","")
            }
        })
    }
    useEffect(()=>{
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/republik/amudaryo/table?month="+month, header())
                .catch(e=>{
                    console.log("Xato",e)
                    alert("Serverga ulanishda xato")
                })
            if(res){
                setData(res.data)
            }
        }
        fetchData();
    },[month])
    const generatePDF= useReactToPrint({
        content: ()=>conponentPDF.current,
        documentTitle:"Amudaryo balansi",
        // onAfterPrint:()=>alert("Data saved in PDF")
    });
    return (
        <div className="table-box-con">
            <div className="table-content-top">
                <div className="table-top-left">
                    <Input
                        prefix={<SearchOutlined className="site-form-item-icon" />}
                        placeholder="Search"
                        onChange={e=>setSearch(e.target.value)}
                    />
                </div>
                <ul className="table-top-right">
                    <li>
                        <button className="btn p-0" onClick={() => generatePDF()}>
                            <img src={print} alt="404"/>
                        </button>
                    </li>
                    <li>
                        <button  onClick={() => Pdf('tblData')} className="btn p-0">
                            <img src={pdf} alt="404"/>
                        </button>
                    </li>
                    <li>
                        <button className="btn p-0" onClick={()=>ExcelPrint("Amudaryo balans", month,"amudaryo")}>
                            <img src={excel} alt="404"/>
                        </button>
                    </li>
                </ul>
            </div>
            <div className="table-responsive tableFixHead" id="tableFlexible">
                <div ref={conponentPDF} style={{width:'100%'}}>
                <table id="tblData" className="table table-bordered table-style">
                    <thead>
                    <tr>
                        <th rowSpan={2} scope="col" className="sticky st1">№</th>
                        <th rowSpan={2} scope="col" className="sticky" style={{left:"36px"}}>Suv olish nuqtalari</th>
                        <th rowSpan={2} scope="col" className="sticky" style={{left:"214px"}}>Yillar</th>
                        <th colSpan={monthDays(month)} scope="col">{monthName(month)}</th>
                    </tr>
                    <tr>
                        {
                            Array(monthDays(month)).fill().map((p,i)=>{
                                return <th scope="col" key={i}>{i+1}</th>
                            })
                        }
                    </tr>
                    </thead>
                    {
                        data.length > 0 ?
                            data.map((d,i)=>{
                                return <tbody key={i}>
                                    <tr className={d.nomi}>
                                        <th scope="row" className="sticky st1">{day++}</th>
                                        <td className="sticky" style={{left:"36px",verticalAlign: "middle"}} rowSpan={2}>{d.nomi}</td>
                                        <td className="sticky" style={{left:"214px"}}>{new Date(month).getFullYear()}</td>
                                        {
                                            Array(monthDays(month)).fill().map((p,i)=>{
                                                return <td key={i}>{d['kun'+(i+1)]?.[0] ?? "-"}</td>
                                            })
                                        }
                                    </tr>
                                    <tr className={d.nomi}>
                                        <th scope="row" className="sticky st1">{day++}</th>
                                        <td className="sticky" style={{left:"214px"}}>{new Date(month).getFullYear()-1}</td>
                                        {
                                            Array(monthDays(month)).fill().map((p,i)=>{
                                                return <td key={i}>{d['kun'+(i+1)]?.[1] ?? "-"}</td>
                                            })
                                        }
                                    </tr>
                                </tbody>
                            })
                            :null
                    }
                </table>
                </div>
            </div>
        </div>
    );
}

export default Page3;